import { createContext, useContext } from 'react';

type CarouselContextValue = {
  // Each item's flex basis, so the items in view share the row between them.
  itemBasis: string;
};

export const CarouselContext = createContext<CarouselContextValue>({
  itemBasis: 'auto',
});

export const useCarouselContext = () => useContext(CarouselContext);
